import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./signin.css";

function SignIn() {
  const navigate = useNavigate();

  const [user, setUser] = useState({
    emailphone: "",
    Password: "",
  });
  const [error, setError] = useState("");

  //user login or not
  useEffect(() => {
    if (localStorage.getItem('auth')) {
      navigate("/");
    }
  }, []);

  const onType = (e) => {
    const { name, value } = e.target;
    setUser({
      ...user,
      [name]: value,
    });
    setError("");
  };

  const submit = async () => {
    if (!user.emailphone || !user.Password) {
      setError("All fields are required");
    }
    let apidata = await fetch(`${process.env.REACT_APP_SERVER}/api/login`, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        emailphone: user.emailphone,
        Password: user.Password,
      }),
    });

    //covert api data into json
    apidata = await apidata.json();

    //error show in component
    if (!apidata.success) {
      setError(apidata.message);
    } else {
      const auth={key:apidata.user._id,name:apidata.user.name}
      localStorage.setItem("auth",JSON.stringify(auth));
      navigate("/");
    }
  };

  return (
    <div className="login">
      <h1>Login</h1>
      <input
        type="text"
        name="emailphone"
        value={user.emailphone}
        onChange={onType}
        placeholder="Enter Email / Phone "
      ></input>
      <input
        type="password"
        name="Password"
        value={user.Password}
        onChange={onType}
        placeholder="Enter your Password"
      ></input>
      <p style={{ color: "red" }}>{error}</p>
      <div className="button" onClick={submit}>
        Login
      </div>
      <div>or</div>
      <div
        className="button"
        onClick={() => {
          navigate("/signup");
        }}
      >
        Register
      </div>
    </div>
  );
}

export default SignIn;
